export const bpProductCarousel = {
  200: {
    slidesPerView: 'auto',
    spaceBetween: 24,
  },
  320: {
    slidesPerView: 'auto',
    spaceBetween: 24,
  },
  375: {
    slidesPerView: 'auto',
    spaceBetween: 24,
  },
  768: {
    slidesPerView: 'auto',
    spaceBetween: 24,
  },
  1024: {
    slidesPerView: 4,
    spaceBetween: 22,
  },
};

export const bpProductBannerCarousel = {
  200: {
    slidesPerView: 'auto',
    spaceBetween: 24,
  },
  320: {
    slidesPerView: 'auto',
    spaceBetween: 24,
  },
  375: {
    slidesPerView: 'auto',
    spaceBetween: 24,
  },
  768: {
    slidesPerView: 'auto',
    spaceBetween: 24,
  },
  1280: {
    slidesPerView: 3,
    spaceBetween: 22,
  },
};

export const bpPlanCarousel = {
  200: {
    slidesPerView: 'auto',
    spaceBetween: 24,
  },
  320: {
    slidesPerView: 'auto',
    spaceBetween: 24,
  },
  375: {
    slidesPerView: 'auto',
    spaceBetween: 24,
  },
  768: {
    slidesPerView: 'auto',
    spaceBetween: 24,
  },
  1024: {
    slidesPerView: 4,
    spaceBetween: 22,
  },
};

export const bpHeroCarousel = {
  200: {
    slidesPerView: 1,
    spaceBetween: 0,
  },
  1024: {
    slidesPerView: 1,
    spaceBetween: 0,
  },
};

export const bpCareerPathsCarousel = {
  200: {
    slidesPerView: 'auto',
    spaceBetween: 24,
  },
  768: {
    slidesPerView: 'auto',
    spaceBetween: 24,
  },
  1024: {
    slidesPerView: 3,
    spaceBetween: 22,
  },
};

export const bpCareerMobilistCarousel = {
  200: {
    slidesPerView: 1,
    spaceBetween: 24,
  },
  1024: {
    slidesPerView: 1,
    spaceBetween: 22,
  },
};

export const bpLocationsCarousel = {
  200: {
    slidesPerView: 1,
    spaceBetween: 24,
  },
  1024: {
    slidesPerView: 1,
    spaceBetween: 22,
  },
};

export const bpCompatibleAccessoriesCarousel = {
  200: {
    slidesPerView: 'auto',
    spaceBetween: 24,
  },
  1024: {
    slidesPerView: 2,
    spaceBetween: 22,
  },
};

export const bpProductGallery = {
  200: {
    slidesPerView: 'auto',
    spaceBetween: 24,
  },
  320: {
    slidesPerView: 'auto',
    spaceBetween: 24,
  },
  768: {
    slidesPerView: 'auto',
    spaceBetween: 24,
  },
  1024: {
    slidesPerView: 'auto',
    spaceBetween: 22,
  },
};
